module.exports = __webpack_public_path__ + "assets/23d54bad1b6d0e026ecd733a4887ff95.png";